import { useDispatch } from 'react-redux'
import { clearDrawerModal, setDrawer } from 'slices/drawer'
import { DRAWER_KEY } from 'app-constants'
import { Button } from 'components/button'
import './style.scss'

export function StoreWithdrawal() {
  const dispatch = useDispatch()

  function handleStayPage() {
    dispatch(clearDrawerModal())
  }

  function handleGoPageHome() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  return (
    <div className='container-withdrawal'>
      <div className='container-content-withdrawal'>
        <span className='withdrawal-title'>Deseja sair sem concluir?</span>
        <p className='withdrawal-text'>
          Você está saindo antes de finalizar sua assinatura. Tudo bem, mas que tal aproveitar
          agora?
        </p>
      </div>
      <div className='container-buttons-withdrawal'>
        <Button className='button-stayPage' color='primary' onClick={handleStayPage}>
          Ficar na página
        </Button>
        <Button className='button-goHome' onClick={handleGoPageHome}>
          Tela inicial
        </Button>
      </div>
    </div>
  )
}
